import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            焦点专题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            深度策划、精选影单，51影院带你发现更多好片
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <article
              key={item.title}
              className="group rounded-2xl bg-background-50 border border-background-200 overflow-hidden hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-[16/9]">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`51影院 - ${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium bg-background-50/90 text-foreground-700 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 line-clamp-1">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}